import { CheckCircleIcon, InfoIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Divider,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  HStack,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { AppContext } from "AppProvider/AppContext";
import React, { useContext, useState } from "react";
import { appRequest } from "routes";
import HeadingSS from "../Heading/HeadingSS";
import {
  handleSaveData,
  transformData,
} from "../PRYViewer/component/utils/functions";
import { transformToinitialOrgAndEditedFormat } from "../fields/utils/functions";
import { combineValues } from "../function";
import { transformDataForInitial } from "../ViewerModal/utils/function";

type ModalProps = {
  isOpen: boolean;
  onClose?: () => void;
  selectedRows: any[];
  setSelectedRows: React.Dispatch<React.SetStateAction<any[]>>;
  commentModel: {
    selectedStatus: string;
    open: boolean;
    comment: string;
  };
  handleClose?: any;
  setCommentModel: React.Dispatch<
    React.SetStateAction<{
      selectedStatus: string;
      open: boolean;
      comment: string;
      isMulti?: boolean;
    }>
  >;
  handleGet: () => void;
  view: boolean;
  width?: any;
  editedValues?: any;
  isMulti?: boolean;
  isTable?: boolean;
  isWord?: boolean;
  isSchema?: boolean;
  selectedFile?: any;
  isMdm?: boolean;
  createNew?: any;
  additionalFields?: any;
  statusType?: any;
  poProcessTypeValue?: string;

};

export default function CommentDrawer({
  isOpen,
  onClose,
  selectedRows,
  setSelectedRows,
  commentModel,
  setCommentModel,
  handleGet,
  view,
  width,
  handleClose,
  editedValues,
  isMulti,
  isTable,
  isWord,
  isMdm,
  isSchema,
  selectedFile,
  createNew,
  additionalFields,
  statusType,
  poProcessTypeValue
}: ModalProps) {
  const [isRegisteredModalOpen, setIsRegisteredModalOpen] = useState(false);

  const [registeredInfo, setRegisteredInfo] = useState<{
    vendorName: string;
    pan: string;
    addresses: string[];
  } | null>(null);
  // const { isOpen, onOpen, onClose } = useDisclosure()
  const [submitLoader, setSubmitLoader] = useState(false);
  const { toastNotify } = useContext(AppContext);
  const { accountDetails, workFlowData, setUpdateDashboardApi, updateDashboardApi } = useContext(AppContext);
  function transformObject(inputObject: any) {
    const transformedObject: any = {};
    for (const key in inputObject) {
      transformedObject[key] = {
        originalValue: inputObject[key],
        editFieldValue: null,
      };
    }

    return transformedObject;
  }

  let responseMessage = "Updated Successfully";

  console.log("the additional files", additionalFields);
  // console.log(editedValues)

  const handleSubmitMultipleData = async () => {
    try {
      let haveData: any = null;
      setSubmitLoader(true);
      const promises = selectedRows.map(async (row) => {
        try {
          let valus = null;
          if (
            !Array.isArray(row.values) &&
            isMulti &&
            workFlowData?.fileViewer?.approvalModalOption === "mdm"
          ) {
            if (Array.isArray(row?.values?.values?.results)) {
              row.values.values = handleSaveData(
                transformData(row?.values?.values?.results)
              );
            }
          }

          if (
            !Array.isArray(row?.values?.values) &&
            isMulti &&
            (workFlowData?.fileViewer?.approvalModalOption === "fields" ||
              workFlowData?.fileViewer?.approvalModalOption ===
              "files_verification")
          ) {
            if (Array.isArray(row?.values?.values?.results)) {
              const transformed = row?.values?.values?.results.map(
                (result: any) => {
                  return transformToinitialOrgAndEditedFormat(result?.fields);
                }
              );

              row.values.values = { results: transformed };
            }
          }

          if (isMulti) {
            valus = Array.isArray(row.values)
              ? row?.values?.[row.values?.length - 1]?.values
              : row?.values?.values;
          } else {
            if (workFlowData?.fileViewer?.approvalModalOption === "isCurebay") {
              valus = editedValues;
            } else if (isWord) {
              valus = editedValues;
            } else if (
              workFlowData?.fileViewer?.approvalModalOption === "mdm"
            ) {
              valus = editedValues;
            } else if (
              workFlowData?.fileViewer?.approvalModalOption === "fields" ||
              workFlowData?.fileViewer?.approvalModalOption ===
              "files_verification"
            ) {
              valus = editedValues;
            } else {
              if (isTable) {
                valus = Array.isArray(row.values)
                  ? row?.values?.[row.values?.length - 1]?.values
                  : row?.values?.values;
              } else if (isSchema) {
                valus = editedValues;
              } else {
                valus = combineValues(
                  Array.isArray(row.values)
                    ? row.values
                    : transformObject(row.values?.values),
                  editedValues || {}
                );
              }
            }
          }

          const updatedStatus = {
            id: row?._id,
            level: accountDetails?.level,
            status: commentModel.selectedStatus,
            comment: commentModel.comment,
            values: valus,
            type: isWord ? "word" : "document",
            activeWorkflow: workFlowData?._id,
            fileId: selectedFile?._id,
            sendNot: workFlowData?.updateFirstUserNotification,
            poProcessTypeValue:poProcessTypeValue || undefined
          };
          const response: any = await appRequest(
            "document",
            "update",
            updatedStatus
          );
          if (response.status !== "success") {
            throw new Error(
              response?.message || `Failed to update document for row`
            );
          }

          if (
            statusType === "exception" &&
            commentModel?.selectedStatus === "approved" &&
            response?.message !== "Something Went Wrong" &&
            !String(response?.message || "").includes("!!!!!!")
          ) {
            const updateExceptionDocument = await appRequest(
              "mmtDocument",
              "updateExceptionDocument",
              {
                documentId: row?._id,
                statusType: statusType
              }
            );
            console.log('the update exception document are', updateExceptionDocument)
          }

          responseMessage = response?.message || "Updated Successfully";

          console.log("the response are", response);
        } catch (error: any) {
          responseMessage = error?.message;
          console.log(error?.message);
          return {
            title: "Error",
            message: error.message,
            type: "error",
          };
        } finally {
          setSelectedRows([]);
        }
      });

      let notifications: any = await Promise.all(promises);

      notifications = notifications.filter((not: any) => not?.type === "error");

      if (notifications.length) {
        notifications.forEach((notification: any) =>
          toastNotify({
            type: "error",
            title: notification.message,
          })
        );
      } else {
        if (!haveData) {
          setCommentModel({
            open: false,
            comment: "",
            selectedStatus: "approved",
          });
          if (handleClose) {
            handleClose();
          }
        }
        toastNotify({
          type: "success",
          title: "Updates submitted",
          message: responseMessage || "Updated successfully.",
        });
        setSelectedRows([]);
      }
    } catch (err: any) {
      console.error(err);
      toastNotify({
        title: "Error",
        message: err?.message || "Failed to update document.",
        type: "error",
      });
    } finally {
      handleGet();
      if (setUpdateDashboardApi) {
        setUpdateDashboardApi(!updateDashboardApi);
      }
      setSubmitLoader(false);
    }
  };
  return (
    <>
      <Drawer
        placement="bottom"
        isOpen={isOpen}
        onClose={() => {
          setCommentModel({
            open: false,
            comment: "",
            selectedStatus: "approved",
          });
          // setSelectedRows([]);
        }}
        size="sm"
      >
        <DrawerOverlay />
        <DrawerContent
          boxSize={{ base: "auto", lg: `${width}` }}
          maxH="33vh"
          ml="auto"
          my="auto"
          borderRadius="md"
        >
          <DrawerHeader>
            <HeadingSS
              headingSS={
                commentModel?.selectedStatus === "approved"
                  ? "Add Your Approval Comment"
                  : "Add Your Rejection Comment"
              }
            />
          </DrawerHeader>
          <DrawerBody>
            <Textarea
              value={commentModel.comment}
              onChange={(e: any) => {
                setCommentModel({ ...commentModel, comment: e.target.value });
              }}
              placeholder="Type your comment here..."
            />
          </DrawerBody>
          <DrawerFooter>
            <Flex justify="flex-end">
              <Button
                fontSize="sm"
                w="5rem"
                bg="green.400"
                _hover={{ bg: "green.500" }}
                color="white"
                mr={3}
                isLoading={submitLoader}
                onClick={async () => {
                  if (createNew) {
                    let originalValues = transformDataForInitial(
                      editedValues?.fields
                    );
                    try {
                      setSubmitLoader(true);
                      let payload = {
                        ...additionalFields,
                        file: {
                          ...additionalFields?.file,
                          file: additionalFields?.file?.file?.split(",").pop(),
                        },
                        type: additionalFields?.type || "schema",
                        values: { valuesData: editedValues },
                        originalValues: originalValues,
                      };
                      const response: any = await appRequest(
                        "document",
                        "create",
                        payload
                      );

                      if (response?.status === "success") {
                        toastNotify({
                          type: "success",
                          title: "document created",
                          message: "Document Created Succesfully",
                        });
                        setCommentModel({
                          open: false,
                          comment: "",
                          selectedStatus: "approved",
                        });
                        handleClose();
                        handleGet();
                        setSubmitLoader(false);
                        return;
                      }
                    } catch (err: any) {
                      console.log(err?.message);
                      setSubmitLoader(false);
                      toastNotify({
                        title: "Error",
                        message: err?.message,
                        type: "error",
                      });
                      return;
                    } finally {
                      setSubmitLoader(false);
                      return;
                    }
                  }

                  const status = commentModel.selectedStatus;
                  const comment = commentModel.comment?.trim() || "";

                  if (
                    (status === "rejected" || status === "approved") &&
                    comment === ""
                  ) {
                    toastNotify({
                      type: "error",
                      message:
                        "Please add a comment before approving or rejecting.",
                    });
                  } else {
                    handleSubmitMultipleData();
                  }
                }}
              >
                <Text>Yes</Text>
              </Button>
              <Button
                w="5rem"
                colorScheme="red"
                fontSize="sm"
                onClick={() => {
                  setCommentModel({
                    open: false,
                    comment: "",
                    selectedStatus: "approved",
                  });
                  setSelectedRows([]);
                }}
              >
                No
              </Button>
            </Flex>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}